import "../styles/layouts/floatinwarning.scss";
import { useCallback, useEffect, useState } from "react";

//TODO: make this more generic...

type Props = {
    visible: boolean,
    getMessage: () => any,
    getExtendedMessage?: () => any,
    customPosition: number
}

export default function FloatingWarning({
    visible,
    getMessage,
    getExtendedMessage,
    customPosition
}: Props) {
    const [visibility, setVisibility] = useState(false);
    const [warningInfoExtended, setWarningInfoExtended] = useState(false);

    useEffect(() => {
        setVisibility(visible);
    }, [visible]);

    const getStyle = useCallback(() => {

        const style: any = {
            visibility: visibility ? "visible" : "hidden",
            opacity: visibility ? "1" : "0",
        };

        if (customPosition) {
            style.top = `${customPosition}vh`;
        }

        return style;
    }, [customPosition, visibility])

    return (
        <div
            style={getStyle()}
            className="floatingWarningContainer"
        >
            <div className="floatingWarningInnerContainer">
                <div className={`floatingWarning`}>
                    <div className="warningContent">{getMessage()}</div>
                </div>

                {getExtendedMessage && (
                    <div
                        className={`warningInfo ${warningInfoExtended ? "warningInfoVisible" : "warningInfoNone"
                            }`}
                    >
                        {getExtendedMessage && getExtendedMessage()}
                    </div>
                )}

                <div className="warningButtons">
                    {getExtendedMessage && (
                        <div
                            onClick={() => {
                                setWarningInfoExtended(true);
                            }}
                            className={`${warningInfoExtended
                                ? "extendedWarningInfo"
                                : "extendWarningInfo"
                                }`}
                        ></div>
                    )}

                    <div
                        onClick={() => {
                            setVisibility(false);
                            setTimeout(() => {
                                setWarningInfoExtended(false);
                            }, 100);
                        }}
                        className="closeButton"
                    ></div>
                </div>
            </div>
        </div>
    );
}
